import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { Tv } from '../../../types/tvs';
import { getRelatedTvs } from '../../../services/tvs';

type Props = {
  tvId: number;
};

export const Component: FunctionComponent<Props> = ({
  tvId,
}) => {
  const [relatedTvs, setRelatedTvs] = useState<Tv[]>([]);

  useEffect(() => {
    const fetchRelatedTvs = async () => {
      try {
        const response = await getRelatedTvs(tvId);
        setRelatedTvs(response.relatedTvs || []);
      } catch (error) {
        console.log(error);
      }
    };
    fetchRelatedTvs();
  }, [tvId]);

  return (
    <Presentation
      relatedTvs={relatedTvs}
    />
  );
};
